import { useState } from "react";
import http, { formatApiErrorDetail } from "@/api";
import { Factory, X } from "lucide-react";

export const PlantLinker = ({ plantas }) => {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [plant, setPlant] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState("");

  const search = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      const r = await http.get("/suppliers", { params: { q } });
      setResults((r.data || []).slice(0, 8));
    } catch (ex) { setErr(formatApiErrorDetail(ex.response?.data?.detail) || ex.message); }
  };

  const link = async (sid) => {
    if (!plant) { setErr("Selecciona primero la planta a asociar."); return; }
    setBusy(sid); setErr("");
    try {
      const r = await http.post(`/admin/suppliers/${sid}/plants`, null, { params: { plant } });
      setResults((rs) => rs.map((s) => (s.id === sid ? { ...s, plants: r.data.plants } : s)));
    } catch (ex) { setErr(formatApiErrorDetail(ex.response?.data?.detail) || ex.message); }
    finally { setBusy(""); }
  };

  const unlink = async (sid, p) => {
    setBusy(sid); setErr("");
    try {
      const r = await http.delete(`/admin/suppliers/${sid}/plants/${encodeURIComponent(p)}`);
      setResults((rs) => rs.map((s) => (s.id === sid ? { ...s, plants: r.data.plants } : s)));
    } catch (ex) { setErr(formatApiErrorDetail(ex.response?.data?.detail) || ex.message); }
    finally { setBusy(""); }
  };

  return (
    <div className="mt-10 sketch-border bg-white p-6" data-testid="plant-linker">
      <div className="font-hand text-xl text-[var(--lala-blue)]">relación proveedor–planta</div>
      <h2 className="font-display text-2xl mb-2">Asociar / retirar plantas manualmente</h2>
      <p className="text-sm text-[var(--ink-soft)] mb-4">
        Busca un proveedor existente y asócialo a una planta (puede pertenecer a varias; retirarlo de una planta no lo elimina).
        El catálogo completo proveedor–planta se cargará cuando LALA entregue el archivo fuente.
      </p>
      <form onSubmit={search} className="flex flex-wrap gap-2 mb-4">
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar proveedor por nombre…"
          className="border border-[var(--line)] rounded-lg px-3 py-2 text-sm flex-1 min-w-[220px]" data-testid="pl-search-input" />
        <select value={plant} onChange={(e) => setPlant(e.target.value)}
          className="border border-[var(--line)] rounded-lg px-3 py-2 text-sm bg-white" data-testid="pl-plant-select">
          <option value="">Planta a asociar…</option>
          {plantas.map((p) => <option key={p} value={p}>{p}</option>)}
        </select>
        <button type="submit" className="btn-primary text-sm" data-testid="pl-search-btn">Buscar</button>
      </form>
      {err && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg p-2 mb-3" data-testid="pl-error">{err}</div>}
      <div className="space-y-2">
        {results.map((s) => (
          <div key={s.id} className="flex flex-wrap items-center gap-2 border border-[var(--line)] rounded-lg p-3 bg-[var(--cream-soft)]"
            data-testid={`pl-supplier-${s.id}`}>
            <span className="font-semibold text-sm flex-1 min-w-[180px]">{s.name}</span>
            {(s.plants || []).map((p) => (
              <span key={p} className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-[var(--lala-blue)] text-white text-[11px] font-semibold"
                data-testid={`pl-chip-${s.id}-${p}`}>
                <Factory size={10} /> {p}
                <button onClick={() => unlink(s.id, p)} disabled={busy === s.id} title="Retirar de esta planta"
                  data-testid={`pl-unlink-${s.id}-${p}`}><X size={11} /></button>
              </span>
            ))}
            <button onClick={() => link(s.id)} disabled={busy === s.id || !plant}
              className="sketch-pill px-3 py-1 text-xs font-semibold disabled:opacity-40" data-testid={`pl-link-${s.id}`}>
              + Asociar {plant || "planta"}
            </button>
          </div>
        ))}
        {results.length === 0 && <div className="text-sm italic text-[var(--ink-soft)]">Busca un proveedor para gestionar sus plantas.</div>}
      </div>
    </div>
  );
};

export default PlantLinker;
